<template>
  <v-list dark v-if="prev[0] || next[0]">
    <v-list-tile
      v-for="phase in next"
      :key="`next-${phase.id}`"
      @click="confirm(phase)"
      :disabled="disabled"
    >
      <v-list-tile-content>
        <v-list-tile-title class="subheading">{{ phase.name }}</v-list-tile-title>
      </v-list-tile-content>
      <v-list-tile-action :style="disabled ? 'opacity: 0.5;' : ''">
        <v-icon :color="!disabled ? 'success' : ''">
          mdi-arrow-right-bold
        </v-icon>
      </v-list-tile-action>
    </v-list-tile>
    <v-list-tile
      v-for="phase in prev"
      :key="`prev-${phase.id}`"
      @click="confirm(phase)"
      :disabled="disabled"
    >
      <v-list-tile-content>
        <v-list-tile-title class="subheading">{{ phase.name }}</v-list-tile-title>
      </v-list-tile-content>
      <v-list-tile-action :style="disabled ? 'opacity: 0.5;' : ''">
        <v-icon :color="!disabled ? 'warning' : ''">
          mdi-arrow-left-bold
        </v-icon>
      </v-list-tile-action>
    </v-list-tile>
    <v-divider v-if="canRegret" />
    <v-list-tile
      v-if="canRegret"
      @click="confirm({ name: 'Unsuccessful' })"
      :disabled="!applications[0]"
    >
      <v-list-tile-content>
        <v-list-tile-title class="subheading">Regret</v-list-tile-title>
      </v-list-tile-content>
      <v-list-tile-action :style="!applications[0] ? 'opacity: 0.5;' : ''">
        <v-icon color="error">mdi-account-off</v-icon>
      </v-list-tile-action>
    </v-list-tile>
    <v-dialog v-model="confirming" max-width="500px">
      <v-card dark>
        <v-card-title>Confirm</v-card-title>
        <v-card-text v-if="newPhase && newPhase.name">
          Please confirm that you would like to move
          <span v-if="applications.length">
            <strong>{{ applications.length }}</strong>
            {{ applications.length | pluralize('candidate') }}
          </span>
          <span v-else-if="applications.profile && applications.profile.firstName">
            <strong>{{ applications.profile.firstName }}</strong>
          </span>
          <span v-else>candidate(s)</span>
          to <strong>{{ newPhase.name }}</strong
          >?
        </v-card-text>
        <v-card-actions v-if="newPhase"
          ><v-spacer />
          <v-btn flat @click.stop="confirming = false">Cancel</v-btn>
          <v-btn
            @click.stop="newPhase.name == 'Unsuccessful' ? regret() : move()"
            :disabled="busy"
            :loading="busy"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    applications: [Array, Object],
    includeRegret: { type: Boolean, default: false },
  },
  data() {
    return {
      confirming: false,
      newPhase: null,
      busy: false,
    }
  },
  computed: {
    phases() {
      return this.$store.getters['admin/opportunities/orderedPhases']
    },

    current() {
      let status = null
      if (this.applications && this.applications.status) {
        status = this.applications.status
      }
      if (this.applications && this.applications[0]) {
        status = this.$store.getters['admin/applications/find'](this.applications[0]).status
      }
      if (status) {
        return {
          name: status,
          index: this.phases.findIndex(p => status === p.name),
        }
      } else {
        return {
          name: 'Unknown',
          index: -1,
        }
      }
    },

    prev() {
      if (this.current && this.current.index > 0) {
        return this.phases.slice(0, this.current.index)
      }
      return []
    },

    next() {
      const length = this.phases.length
      if (this.current && this.current.index < length) {
        return this.phases.slice(this.current.index + 1)
      }
      return this.phases
    },

    canRegret() {
      return this.includeRegret && this.current && this.current.name !== 'Unsuccessful'
    },

    disabled() {
      const authorized = this.$can('edit', 'OpportunityApplication')
      return (
        !authorized ||
        (Object.keys(this.applications).length === 0 && this.applications.length === 0)
      )
    },
  },
  methods: {
    confirm(phase) {
      this.confirming = true
      this.newPhase = phase
    },

    move() {
      this.busy = true
      this.$store
        .dispatch('admin/applications/move', {
          applications: this.applications,
          phase: this.newPhase,
        })
        .then(
          data => {
            this.$store.dispatch('snackbarSuccess', 'Moved successfully')
            this.$emit('done', this.newPhase)
            this.confirming = false
            this.busy = false
            return this.$store.dispatch('admin/applications/updateFilters', {})
          },
          errors => this.$store.dispatch('snackbarError', 'No application was moved')
        )
        .finally(() => {
          this.busy = false
          this.confirming = false
        })
    },

    regret() {
      this.busy = true
      this.$store
        .dispatch('admin/applications/regret', { applications: this.applications })
        .then(
          data => {
            this.$store.dispatch('snackbarSuccess', 'Marked as unsuccessful')
            this.$emit('done')
            this.confirming = false
            this.busy = false
            return this.$store.dispatch('admin/applications/updateFilters', {})
          },
          errors => this.$store.dispatch('snackbarError', 'No change was made')
        )
        .finally(() => {
          this.busy = false
          this.confirming = false
        })
    },
  },
}
</script>
